import { ProductUserGiftListVO } from "@akc/biz-api";
import { RewardGiftActivityDialogComp } from "@akc/mx-taro-h5-components";
import { Popup } from "antd-mobile";
import React from "react";
import styles from "./index.module.less";

type Props = {
  visible?: boolean;
  /** 页面ID */
  pageId?: string;
  /** 活动ID */
  activityId?: string;
  /** 商品ID */
  spuId?: string;
  /** 活动商品ID */
  activitySpuId?: string;
  skuId?: string;
  productName?: string;
  /** 关闭事件 */
  onClose?: () => void;
  /** 跳转规则说明 */
  jumpRuleDescPage?: (actRuleDescUrl?: string) => void;
  /** 跳转凑单页面 */
  jumpPromotionOrderPage?: (rewardGift?: ProductUserGiftListVO) => void;
};

// 尺码角色添加
const RewardGiftActivityDialog: React.FC<Props> = props => {

  //关闭弹窗
  const onClose = () => {
    props?.onClose?.();
  };

  return (
    <React.Fragment>
      <Popup
        style={{ "--z-index": "2000" }}
        maskStyle={{ zIndex: "1999" }}
        visible={props.visible}
        destroyOnClose={true}
        onMaskClick={() => {
          onClose();
        }}
        bodyStyle={{ backgroundColor: "transparent" }}>
        <div className={styles.rewardGift4ActivityC}>
          <RewardGiftActivityDialogComp
            onClose={onClose}
            activityId={props.activityId}
            activitySpuId={props.activitySpuId}
            trackData={{
              product_name: props.productName,
              activity_spu_code: props.activitySpuId,
              resource_type: "C满赠_弹窗",
            }}
            skuId={props.skuId}
            jumpPromotionOrderPage={props.jumpPromotionOrderPage}
            jumpRuleDescPage={props.jumpRuleDescPage}
          />
        </div>
      </Popup>
    </React.Fragment>
  );
};

export default RewardGiftActivityDialog;
